import { connect } from 'react-redux'
import type { State } from 'store/types'

import { toggleDetails, toggleItem } from './actions'
import SearchResults from './SearchResults'
import { getDetails, getListItems, getSearchInputValue, getSelectedIndices, isTyping } from './selectors'

const mapStateToProps = (state: State) => ({
  details: getDetails(state),
  hasFetchError: state.search.hasFetchError,
  isTyping: isTyping(state),
  searchInputValue: getSearchInputValue(state),
  selectedIndices: getSelectedIndices(state),
  showSelectedOnly: state.search.showSelectedOnly,
  stores: getListItems(state),
})

const mapDispatchToProps = {
  toggleDetails,
  toggleItem,
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchResults)
